export default __webpack_public_path__ + "static/certificate-gdpr-455c4c43fac5c524cac91c63148a209f.svg";